import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.section `
  ${fonts.apercu.light};

  font-size: ${fluid(14, 18)};
  line-height: ${fluid(28, 28)};
  margin-bottom: 22px;
`;
const Tag = styled.small `
  background-color: ${brand.yellow};
  margin: 0 ${fluid(15, 30)} 0 0;
  padding: 4px 10px;
`;
const Date = styled.time `
  [data-theme='dark'] & {
    color: ${brand.white};
  }
`;
const ArticleMetaStyles = {
    Container,
    Date,
    Tag,
};
export default ArticleMetaStyles;
